import React, { FC } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Login from '../../views/login/Login';

interface Props {
  show: boolean;
  close: () => void;
}

const LoginModal: FC<Props> = ({ show, close }) => (
  <Modal show={show} onHide={close}>
    <Modal.Header closeButton>
      <Modal.Title>Logg inn</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Login />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="light" onClick={close}>
        Lukk
      </Button>
    </Modal.Footer>
  </Modal>
);

export default LoginModal;
